import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  "fill-rule": "evenodd",
  d: "m4.461 9.092.648-2.43a3.25 3.25 0 0 1 3.14-2.415h7.588a3.25 3.25 0 0 1 3.162 2.497l.56 2.343 1.263-.316a.75.75 0 1 1 .364 1.456l-1.116.279.585.585a3.75 3.75 0 0 1 1.099 2.653v6.259a1.75 1.75 0 0 1-1.75 1.75h-2.001a1.75 1.75 0 0 1-1.75-1.75v-.75H7.747v.75a1.75 1.75 0 0 1-1.75 1.75H3.997a1.75 1.75 0 0 1-1.75-1.75v-6.26c0-.994.394-1.949 1.098-2.652l.586-.585-1.117-.28a.75.75 0 0 1 .364-1.455zm2.097-2.045a1.75 1.75 0 0 1 1.692-1.3h7.587c.81 0 1.515.556 1.703 1.345l.634 2.657H5.838zm8.404 10.706H9.039l.5-1.502h4.922zm.751-2.489.83 2.489h3.71v-2.437l-2.188.182a.75.75 0 1 1-.125-1.494l2.314-.193v-.067c0-.598-.237-1.17-.66-1.593l-.902-.902H5.308l-.902.904c-.423.42-.66.993-.66 1.59v.068l2.314.193a.75.75 0 1 1-.125 1.495l-2.189-.183v2.437h3.712l.83-2.489a.75.75 0 0 1 .711-.513h6.003a.75.75 0 0 1 .711.513m4.54 3.989h-2.5v.75c0 .138.111.25.25.25h2a.25.25 0 0 0 .25-.25zm-16.507 0v.75c0 .138.113.25.25.25h2.002a.25.25 0 0 0 .25-.25v-.75z",
  "clip-rule": "evenodd"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }